"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeRangeSelectorShift = TimeRangeSelectorShift;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _moment = _interopRequireDefault(require("moment"));

var _ButtonWithIcon = require("./ButtonWithIcon");

var _icons = require("../constants/icons");

var _timeRangeSelectorUtils = require("./timeRangeSelectorUtils");

var _Field = require("./Field");

var _SelectIndicators = require("./SelectIndicators");

var _reactSelectUtilities = require("../utilities/reactSelectUtilities");

var _TimeRangeSelectorConstants = require("./TimeRangeSelectorConstants");

var _excluded = ["cssClassModifiers", "disabled", "labels", "saveTimeAndPrecision", "timeAndPrecision", "timeRangeSelectorShiftTypeDefault", "timeRangeSelectorShiftTypeOptions", "useTimeRangeShifter"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function TimeRangeSelectorShift(props) {
  var cssClassModifiers = props.cssClassModifiers,
      disabled = props.disabled,
      labels = props.labels,
      saveTimeAndPrecision = props.saveTimeAndPrecision,
      timeAndPrecision = props.timeAndPrecision,
      timeRangeSelectorShiftTypeDefault = props.timeRangeSelectorShiftTypeDefault,
      timeRangeSelectorShiftTypeOptions = props.timeRangeSelectorShiftTypeOptions,
      useTimeRangeShifter = props.useTimeRangeShifter,
      selectProps = _objectWithoutProperties(props, _excluded);

  var styles = (0, _react.useMemo)(function () {
    return (0, _reactSelectUtilities.getReactSelectStyles)(props.styles);
  }, [props.styles]);
  var shiftRangeOptions = (0, _react.useMemo)(function () {
    return (0, _timeRangeSelectorUtils.getTimeRangeSelectorShiftOptions)(timeRangeSelectorShiftTypeOptions, labels);
  }, [labels, timeRangeSelectorShiftTypeOptions]);

  var _useState = (0, _react.useState)((0, _timeRangeSelectorUtils.getTimeRangeSelectorShiftDefault)(timeRangeSelectorShiftTypeDefault, shiftRangeOptions)),
      _useState2 = _slicedToArray(_useState, 2),
      shiftRangeSelection = _useState2[0],
      setShiftRangeSelection = _useState2[1];

  function shiftBackward() {
    timeAndPrecision.startDateTime = (0, _moment["default"])(timeAndPrecision.startDateTime).subtract(1, shiftRangeSelection.valueField).toDate();
    timeAndPrecision.endDateTime = (0, _moment["default"])(timeAndPrecision.endDateTime).subtract(1, shiftRangeSelection.valueField).toDate();
    saveTimeAndPrecision(timeAndPrecision);
  }

  function shiftForward() {
    timeAndPrecision.startDateTime = (0, _moment["default"])(timeAndPrecision.startDateTime).add(1, shiftRangeSelection.valueField).toDate();
    timeAndPrecision.endDateTime = (0, _moment["default"])(timeAndPrecision.endDateTime).add(1, shiftRangeSelection.valueField).toDate();
    saveTimeAndPrecision(timeAndPrecision);
  }

  if (!useTimeRangeShifter || timeAndPrecision.timeAndPrecisionType !== _TimeRangeSelectorConstants.timeAndPrecisionTypes.fixed) {
    return null;
  }

  return (
    /*#__PURE__*/
    _react["default"].createElement(_Field.Field, {
      cssClassModifiers: cssClassModifiers,
      disabled: disabled,
      label: labels.shiftRange
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "time-range-selector-shift"
    },
    /*#__PURE__*/
    _react["default"].createElement(_ButtonWithIcon.ButtonWithIcon, {
      iconClass: _icons.icons.caretLeft,
      onClick: shiftBackward,
      disabled: disabled
    }),
    /*#__PURE__*/
    _react["default"].createElement(_reactSelect["default"], _extends({}, selectProps, {
      className: "basic-single",
      classNamePrefix: "select",
      components: {
        ClearIndicator: _SelectIndicators.ClearIndicator,
        DropdownIndicator: _SelectIndicators.DropdownIndicator
      },
      getOptionLabel: function getOptionLabel(option) {
        return option.textField;
      },
      getOptionValue: function getOptionValue(option) {
        return option.valueField;
      },
      isClearable: false,
      isDisabled: disabled,
      onChange: setShiftRangeSelection,
      options: shiftRangeOptions,
      styles: styles,
      value: shiftRangeSelection
    })),
    /*#__PURE__*/
    _react["default"].createElement(_ButtonWithIcon.ButtonWithIcon, {
      iconClass: _icons.icons.caretRight,
      onClick: shiftForward,
      disabled: disabled
    })))
  );
}

TimeRangeSelectorShift.propTypes = {
  cssClassModifiers: _propTypes["default"].instanceOf(Array),
  disabled: _propTypes["default"].bool.isRequired,
  useTimeRangeShifter: _propTypes["default"].bool,
  timeAndPrecision: _propTypes["default"].instanceOf(Object),
  saveTimeAndPrecision: _propTypes["default"].func.isRequired,
  timeRangeSelectorShiftTypeDefault: _propTypes["default"].string,
  timeRangeSelectorShiftTypeOptions: _propTypes["default"].instanceOf(Array),
  labels: _propTypes["default"].instanceOf(Object),
  styles: _propTypes["default"].instanceOf(Object)
};
TimeRangeSelectorShift.defaultProps = {
  cssClassModifiers: ['time-range-shifter'],
  useTimeRangeShifter: false,
  timeAndPrecision: {},
  timeRangeSelectorShiftTypeDefault: null,
  timeRangeSelectorShiftTypeOptions: []
};